import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { Label } from 'fw/components';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'

class ConnectToSponsorsInfoTab extends SetupTab {

    urls() {
        return {
            get: API.Biz.url('/vobSetup/getSponsorInfo'),
        }
    }

    getRequest(selectedId) {
        return {
            sponsorId: this.props.selectedId
        }
    }

    privileges() {
        return {
            edit: App.hasPrivilege("SponsorEdit")
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3 className="inline">{this.state.form.sponsorName} <small>{this.state.form.location}</small></h3>
                        <br /><hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Label>Address</Label>
                        <p>{this.state.form.street1}
                            <br />
                            {this.state.form.street2 !== null ?
                                <React.Fragment>
                                    {this.state.form.street2}
                                    <br />
                                </React.Fragment>
                                : ""}
                        {this.state.form.location}</p>
                        <Label>Website</Label> {this.state.form.website}<br />
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

}

export default ConnectToSponsorsInfoTab;



// WEBPACK FOOTER //
// ./src/areas/companyManagement/connectToSponsors/connectToSponsorsInfo/ConnectToSponsorsInfoTab.js